export enum ELeaveContactsActions {
  open = 'leaveContacts/open',
  close = 'leaveContacts/close',
}
